import noty from 'noty'
import $ from 'jquery'
import _ from "underscore"

export function notify(message, type = 'success', options = {}) {
  let customMessage = message
  if (options.layout !== 'topCenter') {
    if (
      ['success', 'error', 'warning', 'information', 'alert'].includes(type)
    ) {
      customMessage = `<span class="icon icon-${
        type === 'alert' ? 'default' : `noty_${type}`
      }"></span><span class="vertical-divider"></span><span class="noty_message_text">${message}</span><span class="icon-cross"></span>`
    }
  }
  let settings = {
    text: customMessage,
    type: type,
    layout: 'topRight',
    theme: 'relax',
    template:
      '<div class="noty_message nf-noty-message noty_custom" aria-live="rude"><span class="noty_text"></span><div class="noty_close"></div></div>',
    position: 'topCenter',
    dismissQueue: true,
    force: true,
    maxVisible: 1,
    animation: {
      open: { height: 'toggle' },
      close: { height: 'toggle' },
      easing: 'swing',
      speed: 500,
    },
    timeout: 5000,
  }
  if (options.layout === 'topCenter') {
    let keysToRemove = ['template', 'animation', 'position', 'maxVisible']
    keysToRemove.forEach((k) => {
      delete settings[k]
    })
  }
  $.extend(settings, options)
  var n = noty(settings)
  $(`#noty_${settings.layout}_layout_container`).attr('aria-live', 'assertive')
  return n
}

export function downloadFile(file_url) {
  let a = document.createElement('a')
  document.body.appendChild(a)
  a.style = 'display: none'
  a.href = file_url
  a.download = 'pdf'
  a.click()
  document.body.removeChild(a)
}

export function getCleanFileName(str, trim = false) {
  str = str
    .replace(/\.(?:(?:[dD][oO][cC][xX]?)|(?:[pP][dD][fF]))$/, '')
    .replace(/[^\w\-]/gi, ' ')
    .replace(/\s\s+/g, ' ')
    .substr(0, 50)
  return trim || !str.trim() ? str.trim() : str
}

export const skillSelectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#F4F4F8",
    boxShadow: "none",
    minWidth: "108px",
    border: "1px solid #E6E8EC !important",
    minHeight: "33px",
    cursor: "pointer",
    borderRadius: "7px",
    outline: "none",
  }),
  placeholder: (styles) => ({ ...styles, color: "#b2b2b2" }),
  option: (styles) => ({ ...styles, cursor: "pointer" }),
  menu: (styles) => ({ ...styles, bottom: "100%", top: "unset"}),
  indicatorSeparator: (styles) => ({ ...styles, width: "0px" }),
  valueContainer: (styles) => ({
    ...styles,
    color: "#222",
    padding: "0px 8px",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    padding: "2px 4px",
    color: "hsl(0, 0%, 50%)",
  }),
}

export const newSkillSelectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#fff",
    boxShadow: "none",
    border: "1px solid #E6E8EC !important",
    minHeight: "33px",
    cursor: "pointer",
    borderRadius: "7px",
    outline: "none",
    width: "130px",
  }),
  placeholder: (styles) => ({ ...styles, color: "#b2b2b2" }),
  option: (styles) => ({ ...styles, cursor: "pointer" }),
  menu: (styles) => ({ ...styles, bottom: "100%", top: "unset"}),
  indicatorSeparator: (styles) => ({ ...styles, width: "0px" }),
  valueContainer: (styles) => ({
    ...styles,
    color: "#222",
    padding: "0px 8px",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    padding: "2px 4px",
    color: "hsl(0, 0%, 50%)",
  }),
}

export const personalFieldSelectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#F4F4F8",
    color: "#222",
    fontWeight: "500",
    fontSize: "16px",
    boxShadow: "none",
    border: "1px solid #E6E8EC !important",
    minHeight: "44px",
    cursor: "pointer",
    borderRadius: "7px",
    outline: "none",
  }),
  placeholder: (styles) => ({ ...styles, color: "#b2b2b2" }),
  option: (styles) => ({ ...styles, cursor: "pointer" }),
  indicatorSeparator: (styles) => ({ ...styles, width: "0px" }),
  valueContainer: (styles) => ({
    ...styles,
    color: "#222",
    padding: "0px 8px",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    padding: "2px 4px",
    color: "hsl(0, 0%, 50%)",
  }),
}

export const skillOptions = [
  { value: "beginner", label: "Beginner" },
  { value: "intermediate", label: "Intermediate" },
  { value: "advanced", label: "Advanced" },
]

export function removeLogoUrls(data) {
  let temp = $.extend(true, {}, data)
  let logosData = temp.images?.logos || []
  _.map(logosData, logo => {
    delete logo['url']
    delete logo['uploading']
  })
  return temp
}